var map = {
	"./jupiter.svg": "17fb",
	"./mars.svg": "f35d",
	"./mercury.svg": "f9c7",
	"./moon.svg": "04e9",
	"./neptune.svg": "31fe",
	"./pluto.svg": "60dd",
	"./saturn.svg": "0d2a",
	"./southnode.svg": "8e13",
	"./sun.svg": "fec6",
	"./truenode.svg": "ba7e",
	"./uranus.svg": "26d1",
	"./venus.svg": "a5a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8908";